import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
  Divider,
  Button,
} from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Chatbox from '../../../commun/ChatBox';

const StatistiquesRecruteursPage = () => {
  const [recruteurs, setRecruteurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');

  useEffect(() => {
   const fetchRecruteurs = async () => {
  try {
    const token = localStorage.getItem('authToken'); 
    const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/recruteurs/stats`, {
      headers: {
        Authorization: `Bearer ${token}`  
      }
    });
    setRecruteurs(res.data || []);
  } catch (error) {
    console.error('Erreur chargement statistiques recruteurs', error);
  } finally {
    setLoading(false);
  }
};

    fetchRecruteurs();
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        <Box textAlign="center" mt={10}>
          <CircularProgress />
          <Typography variant="body1" mt={2}>Chargement des statistiques recruteurs...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <Typography variant="h4" align="center" mb={4}>
        Statistiques des recruteurs
      </Typography>

      {recruteurs.length === 0 ? (
        <Typography align="center" color="textSecondary">
          Aucun recruteur trouvé.
        </Typography>
      ) : (
        <Paper variant="outlined" sx={{ maxWidth: 900, margin: 'auto', p: 2 }}>
          <List>
            {recruteurs.map((rec) => (
              <React.Fragment key={rec._id}>
                <ListItem
                  button
                  onClick={() => navigate(`/admin/recruteur/${rec._id}`)}
                  alignItems="flex-start"
                >
                  <ListItemAvatar>
                    {rec.avatarUrl ? (
                      <Avatar alt={rec.nom} src={rec.avatarUrl} />
                    ) : (
                      <Avatar>
                        <PersonIcon />
                      </Avatar>
                    )}
                  </ListItemAvatar>
                  <ListItemText
                    primary={rec.nom}
                    secondary={
                      <>
                        <Typography component="span" variant="body2" color="textPrimary">
                          Missions prises: {rec.missionsPrises} — Candidatures: {rec.candidaturesPresentees} — Recrutés: {rec.recrutes}
                        </Typography>
                        <br />
                        <Typography component="span" variant="caption" color="textSecondary">
                          Niveau: {rec.niveau || 'Débutant'}
                        </Typography>
                      </>
                    }
                  />
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/admin/recruteur/${rec._id}`);
                    }}
                  >
                    Détails
                  </Button>
                </ListItem>
                <Divider component="li" />
              </React.Fragment>
            ))}
          </List>
        </Paper>
      )}
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
      </DashboardLayout>
  );
};

export default StatistiquesRecruteursPage;
